module.exports = __webpack_public_path__ + "static/media/1-1.1d374eca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/1-1.jpg
// module id = 262
// module chunks = 0